import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import RolesForm from './RolesForm';
import CardHeader from 'react/shared/components/true_link/main/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/main/form/wizard/NextPageButton';
import WizardCard from 'react/signups/card/common/WizardCard';
import rolesDataShape from 'react/signups/card/shapes/RolesData';

export default function Roles({ rolesData, setRolesData }) {
  const validationSchema = Yup.object().shape({
    roles: Yup.array().min(1, 'Please select at least one option'),
    rolesOther: Yup.string().when('roles', {
      is: (values) => values.includes('other'),
      then: () => Yup.string().required('This field is required'),
    }),
  });

  const handleContinue = (values) => {
    setRolesData({
      roles: values.roles,
      rolesOther: values.rolesOther,
    });
  };

  return (
    <>
      <WizardCard>
        <CardHeader>{'What is your role?'}</CardHeader>
        <Formik
          initialValues={rolesData}
          onSubmit={handleContinue}
          validationSchema={validationSchema}
        >
          {({ handleChange, handleSubmit, setFieldTouched, setFieldValue, values }) => (
            <>
              <RolesForm
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
                values={values}
              />
              <NextPageButton disabled={!values.roles.length} onClick={handleSubmit} />
            </>
          )}
        </Formik>
      </WizardCard>
    </>
  );
}

Roles.propTypes = {
  rolesData: rolesDataShape.isRequired,
  setRolesData: PropTypes.func.isRequired,
};
